var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QuestionsStars',{attrs:{"amount":_vm.poll.starsAmount,"locked":_vm.locked},model:{value:(_vm.localResponse.numberValue),callback:function ($$v) {_vm.$set(_vm.localResponse, "numberValue", $$v)},expression:"localResponse.numberValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }